import { GoEyeClosed } from "react-icons/go";
import { GetAllEventsOutput } from "~/types/EventTypesInferred";

type Props = {
    event: GetAllEventsOutput;
};

export const PrivateTag = ({ event }: Props) => {
    if (!event.private) {
        return null;
    }

    return (
        <div
            className={`
                absolute 
                bottom-2 
                z-30
                m-2 
                flex 
                h-8 
                items-center
                justify-start
                py-2 
                text-black 
            `}
        >
            <span
                className={`
                absolute
                flex
                flex-row
                items-center
                gap-2
                pl-4
                text-[16px]
                font-[500]
                leading-relaxed`}
            >
                <GoEyeClosed /> Private
            </span>
            <svg
                width="150"
                height="48"
                viewBox="0 0 150 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M105.223 0H10C4.47715 0 0 4.47715 0 10V38C0 43.5228 4.47715 48 10 48H147.575C148.914 48 150 46.9144 150 45.5753V43.5992C150 35.3166 143.286 28.6023 135.003 28.6023H133.825C128.56 28.6023 124.291 24.3337 124.291 19.0682C124.291 8.53713 115.754 0 105.223 0Z"
                    fill="#E2FF05"
                />
            </svg>
        </div>
    );
};
